// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"937c3460","144":"75716e48","244":"7cbb3d36","378":"dedb9a66","453":"e2ba21ab","572":"da55676d","997":"7d7528fa"}[chunkId] + ".chunk.js";
};